import { render, staticRenderFns } from "./ReportingDemographics.vue?vue&type=template&id=0da5147a&scoped=true&"
import script from "./ReportingDemographics.vue?vue&type=script&lang=js&"
export * from "./ReportingDemographics.vue?vue&type=script&lang=js&"
import style0 from "./ReportingDemographics.vue?vue&type=style&index=0&id=0da5147a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5147a",
  null
  
)

export default component.exports